import { apiAuth, apiDownloadAuth } from "./base";

export function getAllInfrastructures(params) {
  let api = apiAuth();
  return api.get("v1/infrastructures", { params });
}

export function getInfrastructureById(id, params) {
  let api = apiAuth();
  return api.get(`/v1/infrastructures/${id}`, { params });
}

export function createNewInfrastructure(data) {
  let api = apiAuth();
  return api.post(`/v1/infrastructures`, data);
}

export function updateInfrastructureById(id, data) {
  let api = apiAuth();
  return api.put(`/v1/infrastructures/${id}`, data);
}

export function deleteInfrastructureById(id) {
  let api = apiAuth();
  return api.delete(`/v1/infrastructures/${id}`);
}

export function addNewIncident(report_id, data) {
  let api = apiAuth();
  return api.post(`/v1/infrastructures/${report_id}/incidents`, data);
}

export function getIncidentById(id, report_id) {
  let api = apiAuth();
  return api.get(`/v1/infrastructures/${report_id}/incidents/${id}`);
}

export function updateIncidentById(id, report_id, data) {
  let api = apiAuth();
  return api.put(`/v1/infrastructures/${report_id}/incidents/${id}`, data);
}

export function deleteIncidentById(id, report_id, data) {
  let api = apiAuth();
  return api.delete(`/v1/infrastructures/${report_id}/incidents/${id}`, data);
}

export function downloadPerformanceProject(params = {}) {
  let api = apiDownloadAuth();
  return api.get("v1/infrastructures/export/xlsx", { params });
}

export function createOlt(data) {
  let api = apiAuth();
  return api.post(`/v1/olt`, data);
}

export function showAllOlt(params) {
  let api = apiAuth();
  return api.get("v1/olt/show-all", { params });
}

export function getAllOlt(params) {
  let api = apiAuth();
  return api.get("v1/olt", { params });
}

export function getOltById(id) {
  let api = apiAuth();
  return api.get(`/v1/olt/${id}`);
}

export function getUnconfiguredDeviceByOltId(id) {
  let api = apiAuth();
  return api.get(`/v1/olt/${id}/unconfigured-devices`);
}

export function updateOltById(id, data) {
  let api = apiAuth();
  return api.put(`/v1/olt/${id}`, data);
}

export function deleteOltById(id) {
  let api = apiAuth();
  return api.delete(`/v1/olt/${id}`);
}

export function getAllFramedPools(params) {
  let api = apiAuth();
  return api.get("v1/framed-pools", { params });
}

export function getFramedPoolById(id) {
  let api = apiAuth();
  return api.get(`/v1/framed-pools/${id}`);
}

export function createFramedPool(data) {
  let api = apiAuth();
  return api.post(`/v1/framed-pools`, data);
}

export function updateFramedPoolById(id, data) {
  let api = apiAuth();
  return api.put(`/v1/framed-pools/${id}`, data);
}

export function deleteFramedPoolById(id) {
  let api = apiAuth();
  return api.delete(`/v1/framed-pools/${id}`);
}

export function createOltProfile(data) {
  let api = apiAuth();
  return api.post(`/v1/olt-profiles`, data);
}

export function showAllOltProfile() {
  let api = apiAuth();
  return api.get("v1/olt-profiles/show-all");
}

export function getAllOltProfile(params) {
  let api = apiAuth();
  return api.get("v1/olt-profiles", { params });
}

export function getOltProfileById(id) {
  let api = apiAuth();
  return api.get(`/v1/olt-profiles/${id}`);
}

export function updateOltProfileById(id, data) {
  let api = apiAuth();
  return api.put(`/v1/olt-profiles/${id}`, data);
}

export function deleteOltProfileById(id) {
  let api = apiAuth();
  return api.delete(`/v1/olt-profiles/${id}`);
}

export function getOltReportById(id) {
  let api = apiAuth();
  return api.get(`/v1/olt-reports/${id}`);
}

export function getProjectOltPreset() {
  let api = apiAuth();
  return api.get(`/v1/olt-reports/projects`);
}

export function updateOltCard(olt_id, card_id, data) {
  let api = apiAuth();
  return api.put(`/v1/olt-reports/${olt_id}/cards/${card_id}`, data);
}

export function updateOltPort(olt_id, data) {
  let api = apiAuth();
  return api.put(`/v1/olt-reports/${olt_id}/port-info`, data);
}

export function syncOltCard(olt_id, card_id) {
  let api = apiAuth();
  return api.post(`/v1/olt-reports/${olt_id}/cards/${card_id}/sync`);
}

export function downloadOltCard(olt_id) {
  let api = apiDownloadAuth();
  return api.get(`v1/olt-reports/${olt_id}/export/xlsx`);
}

export function showAllOdp(params) {
  let api = apiAuth();
  return api.get("v1/odp/all", { params });
}

export function getAllOdp(params) {
  let api = apiAuth();
  return api.get("v1/odp", { params });
}

export function createOdp(data) {
  let api = apiAuth();
  return api.post("v1/odp", data);
}

export function getOdpById(id) {
  let api = apiAuth();
  return api.get(`/v1/odp/${id}`);
}

export function updateOdpById(id, data) {
  let api = apiAuth();
  return api.put(`/v1/odp/${id}`, data);
}

export function deleteOdpById(id) {
  let api = apiAuth();
  return api.delete(`/v1/odp/${id}`);
}
